module.exports = __webpack_public_path__ + "img/ÖGA.b02ce692.svg";